export function toBoolean(str) {
  if (str === 'false') {
    return false;
  }
  if (str === 'true') {
    return true;
  }
  return str;
}
